import AboutSection from "../sections/AboutSection";
import WhyChoose from "../sections/WhyChoose";
import HowItWorks from "../sections/HowItWorks";
import StatsSection from "../sections/StatsSection";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { Reveal, usePageMeta } from "../lib/motion";
import { IMAGES } from "../data/content";

const AboutPage = () => {
  usePageMeta("About Us", "Learn about The Trip World — a professional immigration and visa consultancy based in Ahmadgarh, Punjab.");
  return (
    <main data-testid="about-page">
      <PageHero
        eyebrow="ABOUT US"
        title="YOUR JOURNEY."
        highlight="OUR GUIDANCE."
        description="The Trip World is a professional immigration and visa consultancy based in Ahmadgarh, Punjab — helping people explore international travel, work, study and immigration opportunities."
        image={IMAGES.aboutSecondary}
      />
      <section className="py-20 lg:py-28 bg-navy-deep">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          <Reveal>
            <p className="text-slate-300 text-lg leading-relaxed">
              Founded and led by <span className="text-gold font-semibold">Mr. Dheeraj Kataria</span>, The Trip
              World was built on a simple belief: every applicant deserves honest advice and a well-organised
              application.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-slate-400 leading-relaxed">
              From our office near the Bus Stand in Ahmadgarh, we serve clients across Punjab and beyond —
              providing personalized consultation, documentation guidance and application assistance for work
              permits, visitor visas, student visas, family and spouse visas, and business travel.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-slate-400 leading-relaxed">
              We do not make promises we cannot keep. Instead, we offer a transparent process, clear
              communication and professional support at every relevant stage of your application — because your
              journey matters to us.
            </p>
          </Reveal>
        </div>
      </section>
      <AboutSection />
      <StatsSection />
      <WhyChoose />
      <HowItWorks />
      <CtaBand />
    </main>
  );
};

export default AboutPage;
